<div class="container-fluid p-0 m-0 h-100 overflow-auto">
  <router-outlet></router-outlet>
</div>

<styled-toast></styled-toast>
